var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ]
    },
    [
      _vm.resData
        ? _c(
            "div",
            { staticClass: "package-box" },
            [
              _c(
                "el-dialog",
                {
                  staticStyle: {},
                  attrs: {
                    visible: _vm.show,
                    "before-close": _vm.onCloseDialog
                  }
                },
                [
                  _c("div", { staticClass: "work-title" }, [
                    _c("h3", { staticStyle: { margin: "0" } }, [
                      _vm._v("工单：" + _vm._s(_vm.work_id))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "header-box" }, [
                    _vm._v("拆包信息")
                  ]),
                  _vm._v(" "),
                  _vm.resData.work
                    ? _c(
                        "el-form",
                        {
                          ref: "form",
                          attrs: { model: _vm.form, "label-width": "130px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "寄回运单号：" } },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.resData.work.back_shipping_num)
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品名称:" } },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.resData.work.goods_name) +
                                  "\n        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品图片：" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { width: "50px", height: "50px" }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      height: "100%",
                                      width: "100%"
                                    },
                                    attrs: { src: _vm.resData.work.main_img },
                                    on: {
                                      click: function($event) {
                                        return _vm.imgClick(
                                          _vm.resData.work.middle_img
                                        )
                                      }
                                    }
                                  })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-top": "10px" },
                              attrs: { label: "用户上传图片：" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { width: "50px", height: "50px" }
                                },
                                [
                                  _c("img", {
                                    directives: [
                                      { name: "viewer", rawName: "v-viewer" }
                                    ],
                                    staticStyle: {
                                      height: "100%",
                                      width: "100%"
                                    },
                                    attrs: { src: _vm.resData.work.picture }
                                  })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "颜色-尺码：" } },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.resData.work.co_val) +
                                    "/" +
                                    _vm._s(_vm.resData.work.si_val)
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "问题类型:" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { size: "small" },
                                  model: {
                                    value: _vm.model.id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "id", $$v)
                                    },
                                    expression: "model.id"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { value: 0, label: "全部" }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(_vm.problem, function(item) {
                                    return _c("el-option", {
                                      key: item.problem_id,
                                      attrs: {
                                        value: item.problem_id,
                                        label: item.problem_name
                                      }
                                    })
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  attrs: { size: "small" },
                                  model: {
                                    value: _vm.model.sub_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "sub_id", $$v)
                                    },
                                    expression: "model.sub_id"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { value: 0, label: "全部" }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(_vm.subPorblem, function(item) {
                                    return _c("el-option", {
                                      key: item.problem_id,
                                      attrs: {
                                        value: item.problem_id,
                                        label: item.problem_name
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "拆包件数：" } },
                            [_c("div", [_vm._v(_vm._s(_vm.resData.work.num))])]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "登记类型：" } },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { data: _vm.resData.work_dbid }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "blp_type_index",
                                      label: "类型"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.getBlpText(
                                                      scope.row.blp_type_index
                                                    )
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2130608593
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { prop: "num", label: "数量" }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { prop: "blp_note", label: "备注" }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "blp-img-up",
                                      label: "图片"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              scope.row.blp_img &&
                                              scope.row.num > 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "viewer",
                                                          rawName: "v-viewer"
                                                        }
                                                      ],
                                                      ref: "“uploadImg”",
                                                      staticClass: "blp-img-up"
                                                    },
                                                    [
                                                      scope.row.blp_img
                                                        ? _c("img", {
                                                            staticClass:
                                                              "avatar",
                                                            staticStyle: {
                                                              width: "50px",
                                                              height: "50px"
                                                            },
                                                            attrs: {
                                                              src:
                                                                scope.row
                                                                  .blp_img
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2290815484
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.handle_type_index == 1
                    ? _c(
                        "div",
                        [
                          _c("div", { staticClass: "header-box" }, [
                            _vm._v("\n          收件人信息"),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  color: "red"
                                }
                              },
                              [_vm._v("（如不填写，默认为原订单收件人地址）")]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form",
                            {
                              ref: "form",
                              attrs: { model: _vm.form, "label-width": "130px" }
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "寄出地址：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        size: "mini",
                                        placeholder: "省"
                                      },
                                      on: { change: _vm.getCity },
                                      model: {
                                        value: _vm.form.province,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "province", $$v)
                                        },
                                        expression: "form.province"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "全部", value: 0 }
                                      }),
                                      _vm._v(" "),
                                      _vm._l(_vm.resData.province, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id
                                          }
                                        })
                                      })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        size: "mini",
                                        placeholder: "市"
                                      },
                                      on: { change: _vm.getDistrict },
                                      model: {
                                        value: _vm.form.city,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "city", $$v)
                                        },
                                        expression: "form.city"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "全部", value: 0 }
                                      }),
                                      _vm._v(" "),
                                      _vm._l(_vm.city, function(item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id
                                          }
                                        })
                                      })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        size: "mini",
                                        placeholder: "区/县"
                                      },
                                      model: {
                                        value: _vm.form.district,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "district", $$v)
                                        },
                                        expression: "form.district"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "全部", value: 0 }
                                      }),
                                      _vm._v(" "),
                                      _vm._l(_vm.district, function(item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id
                                          }
                                        })
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "300px" },
                                    attrs: {
                                      placeholder: "地址1",
                                      size: "mini"
                                    },
                                    model: {
                                      value: _vm.form.address,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "address", $$v)
                                      },
                                      expression: "form.address"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "收件人姓名：" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "300px" },
                                    attrs: {
                                      placeholder: "收件人姓名",
                                      size: "mini"
                                    },
                                    model: {
                                      value: _vm.form.consignee,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "consignee", $$v)
                                      },
                                      expression: "form.consignee"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "收件人电话：" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "300px" },
                                    attrs: {
                                      placeholder: "收件人电话",
                                      size: "mini"
                                    },
                                    model: {
                                      value: _vm.form.mobile,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "mobile", $$v)
                                      },
                                      expression: "form.mobile"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resData
                    ? _c(
                        "span",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.onCloseDialog } },
                            [_vm._v("取 消")]
                          ),
                          _vm._v(" "),
                          _vm.handle_type_index == 1
                            ? _c(
                                "span",
                                [
                                  _vm.hanle_status != 7 && _vm.hanle_status != 8
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.submitData }
                                        },
                                        [_vm._v("确 定")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showImg
        ? _c("preview-image", {
            attrs: { imgs: _vm.imgs, show: _vm.showImg },
            on: { closeBox: _vm.closeImg }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99e75218", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99e75218","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/work/components/CbAddressInfo.vue
// module id = null
// module chunks = 